import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import styles from './map.module.scss';

const cx = classnames.bind(styles);

declare global {
  interface Window {
    kakao: any;
  }
}

type KakaoMapsServicesStatusType =
  | 'OK' //검색 결과 있음
  | 'ZERO_RESULT' // 정상적으로 응답 받았으나 검색 결과는 없음
  | 'ERROR'; //서버 응답에 문제가 있는 경우

interface KakaoMapPosition {
  La: number;
  Ma: number;
}

interface KakaoMap {
  setCenter: (coords: KakaoMapPosition) => void;
}

interface AddressSearchResult {
  x: number;
  y: number;
  address: {
    address_name: string;
  };
}

interface KakaoMapProps {
  address: string;
}

const KakaoMap = ({ address }: KakaoMapProps) => {
  useEffect(() => {
    initMap();
  }, []);

  const initMap = () => {
    if (!window.kakao) return;
    const { kakao } = window;
    const mapEl = document.getElementById('map');
    if (!kakao?.maps?.LatLng) return;
    const options = {
      center: new kakao.maps.LatLng(127.1, 37.4),
      level: 3,
    };
    searchAddress(new kakao.maps.Map(mapEl, options));
  };

  const searchAddress = (map: KakaoMap) => {
    const { kakao } = window;
    if (!kakao?.maps?.LatLng) return;
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(address, (result: AddressSearchResult[], status: KakaoMapsServicesStatusType) => {
      switch (status) {
        case 'OK':
          const coords: KakaoMapPosition = new kakao.maps.LatLng(result[0].y, result[0].x);
          new kakao.maps.Marker({ map, position: coords });
          map.setCenter(coords);
          break;
        case 'ERROR':
        case 'ZERO_RESULT':
        default:
          break;
      }
    });
  };

  return <div id={'map'} className={cx('mapArea')} />;
};

export default KakaoMap;
